module.exports = __webpack_public_path__ + "media/images/press_kit/shoretime_dark/email/top-small-429de91109ce197b62a485ce6c06c3a5.png";